import React from "react";
import { useField } from "formik";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";


const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (errors) {
    classes.push("is-invalid-select");
  }

  if (!errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};


export function Select({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  type = "select",
  customFeedbackLabel,
  children,
  ...props
}) {
  // const [field, meta] = useField(props);
  // const { touched, error } = meta;

  // console.log("props :")
  // console.log(touched)
  // console.log(errors)
  return (
    <>

      {label && <label> {label}</label>}
      <select
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
      >
        {children}
      </select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}

      {/* {!!errors[field.name] && (
        <div style={{ color: "red", marginTop: ".5rem" }}>
          {errors[field.name]}
        </div>
      )} */}


    </>
  );
}
